import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as cl from "classnames"
import * as React from "react"
import Popup from '../../ppi/ppi-detail/utils/popup'
import * as Model from "../../../model"


export default class AccountYearEditor extends React.Component<Props, State> {
	constructor(props: Readonly<Props>) {
		super(props)
		this.state = {
			edit: false,
			value: this.props.value
		}
	}
	handleButtonClick(e) {
		e.preventDefault()
		this.setState({ edit: true })
	}
	render() {
		const className = cl("account-year-editor")
		const { value } = this.state
		const year = this.props.scenario.year
		const isAdmin = this.props.currentUser.roles[0].toUpperCase().includes("admin".toUpperCase())
		const currentYear = (new Date()).getFullYear()
		const { currentYearUpdateScenarioParGestionnaire, nextYearUpdateScenarioParGestionnaire } = this.props.localAuthority
		const iseditable = isAdmin ? true : year == currentYear ? currentYearUpdateScenarioParGestionnaire : year == currentYear + 1 ? nextYearUpdateScenarioParGestionnaire : false
		return <div className={className}>
			<div className="account-year-actions">
				<div className="dummy" />
			</div>

			<div className="account-year-editor-value">
				{Math.round(value)}
			</div>
			{iseditable && <div>
				<button className="account-year-editor-value" onClick={(e) => this.handleButtonClick(e)}>
					<FontAwesomeIcon icon='plus-square' />
				</button>
			</div>}
			{this.renderPopup()}
		</div>
	}
	private renderPopup(): React.ReactNode {
		if (this.state.edit)
			return <Popup
				onHide={() => this.setState({ edit: false })}
				title="Mise à jour de la valeur">
				<div className="edit-box-content">
					<strong>{this.props.row.account.label}</strong>

					<form onSubmit={e => {
						e.preventDefault()
						this.setState({ edit: false })
					}}>
						<div className="columns is-desktop">
							<div className="column">
								<p className="field is-horizontal">
									<span className="field-label is-normal">
										<label className="label" htmlFor="amount">Amount</label>
									</span>
									<span className="field-body">
										<span className="field">
											<span className="control">
												<input
													className="input"
													name="amount"
													required
													type="number"
													value={this.state.value}
													onChange={e => this.setState({ value: e.target.value })} />
											</span>
										</span>
									</span>
								</p>
							</div>
						</div>

						<button className="button is-primary">Enregistrer</button>
					</form>
				</div>
			</Popup>
	}
}

interface Induced {
	project: string;
	total: number;
}

interface Induceds {
	items: Induced[];
	total: number;
}

interface Props {
	col: number;
	consulted: boolean;
	row: any;
	scenario: Model.Scenario;
	type: string;
	value: any;
	localAuthority: any
	currentUser: any
}

interface State {
	edit: boolean;
	value: any
}



// WEBPACK FOOTER //
// ./src/component/scenarii/admin/account-year-editor.tsx